import { gql } from '@apollo/client';

export const GET_PENDING_UPDATES = gql`
  query GetPendingUpdates {
    vm {
      enterprisePendingUpdates {
        rootEntityType
        rootEntityId
        name
        pushedAt
        changeCount
        changes {
          diffId
          diffType
          pushMode
          entityType
          fieldPath
          fieldLabel
          entityLabel
          itemName
          itemFieldType
          masterValue
          subCurrentValue
          summary
        }
      }
    }
  }
`;
